import React, { useState, useEffect } from 'react';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.forceshift.ai';

const Dashboard = () => {
  const [expandedPatch, setExpandedPatch] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/v1/prism/tasks`, {
      headers: {
        'X-ForceShift-Key': 'sk_forceshift_dev_777'
      }
    })
      .then(res => res.json())
      .then(data => {
          console.log("[ SYS::INCOMING_CORE_DATA ]", data);
          // Защита от ошибок: если data - массив, ставим его. Иначе пустой массив.
          if (Array.isArray(data)) {
              setTasks(data);
          } else if (data && Array.isArray(data.data)) {
              setTasks(data.data);
          } else {
              setTasks([]);
          }
      })
      .catch(err => console.error("[ SYS::FETCH_ERROR ]", err))
      .finally(() => setIsLoading(false));
  }, []);

  const togglePatch = (id) => {
    if (expandedPatch === id) {
      setExpandedPatch(null);
    } else {
      setExpandedPatch(id);
    }
  };

  const handleDeleteTask = async (taskId) => {
    if (!window.confirm('[ CONFIRM ] Permanently delete this patch?')) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/v1/prism/tasks/${taskId}`, {
        method: 'DELETE',
        headers: { 'X-ForceShift-Key': 'sk_forceshift_dev_777' }
      });
      if (res.ok) {
        setTasks(prev => prev.filter(t => (t.task_id || t.id) !== taskId));
      } else {
        const data = await res.json();
        console.error('[ SYS::DELETE_FAILED ]', data.detail || data);
      }
    } catch (err) {
      console.error('[ SYS::DELETE_ERROR ]', err);
    }
  };

  return (
    <div className="fs-dashboard-container">
      {/* Background Core Glow */}
      <div className="core-glow"></div>

      <header className="dashboard-header">
        <h1>OMNI-PRISM CORE</h1>
        <div className="status-line">
          <span>{isLoading ? 'SYS::FETCHING_DATA' : 'SYS::AGGREGATION_ACTIVE'}</span>
          <span className="blink">_</span>
        </div>
      </header>

      <main className="patch-grid">
        {isLoading && (
          <div style={{ color: '#00F0FF', gridColumn: '1 / -1', textAlign: 'center', marginTop: '2rem' }}>
            [ SYS::FETCHING_DATA... ]
          </div>
        )}

        {error && (
          <div className="error-log" style={{ gridColumn: '1 / -1', textAlign: 'center' }}>
            !! ERROR: {error} !!
          </div>
        )}

        {!isLoading && !error && tasks.length === 0 && (
          <div style={{ color: '#888', gridColumn: '1 / -1', textAlign: 'center', marginTop: '2rem' }}>
            NO DATA IN THE CORE YET.
          </div>
        )}

        {!isLoading && tasks.map((patch) => {
          // Format accessibility notes safely
          let notes = "NO ACCESSIBILITY NOTES";
          if (patch.bdui_json_patch && patch.bdui_json_patch.accessibility_notes) {
            notes = patch.bdui_json_patch.accessibility_notes;
          }

          // Ensure bdui_json_patch is an object for rendering
          let patchObj = patch.bdui_json_patch;
          if (typeof patchObj === 'string') {
            try {
              patchObj = JSON.parse(patchObj);
            } catch (e) {
              // Ignore parse errors, render string as fallback
            }
          }
          if (patchObj && patchObj.accessibility_notes) {
            notes = patchObj.accessibility_notes;
          }

          const safeId = patch.id || patch.task_id;
          const safeUrl = patch.target_url || patch.url;

          return (
            <div key={safeId} className="patch-card">
              
              {/* TOP: Task ID and Status */}
              <div className="card-header">
                <span className="task-id">{safeId}</span>
                <span className={`status-badge ${patch.status ? patch.status.toLowerCase() : 'unknown'}`}>
                  [ SYS::{patch.status ? patch.status.toUpperCase() : 'UNKNOWN'} ]
                </span>
              </div>

              {/* MIDDLE: Accessibility Notes (Terminal Style) */}
              <div className="terminal-block">
                <div className="term-header">
                  <span>&gt; _ACCESSIBILITY_NOTES</span>
                  <span className="term-url">
                    {safeUrl ? (() => { try { return new URL(safeUrl).hostname } catch(e) { return safeUrl } })() : 'UNKNOWN_TARGET'}
                  </span>
                </div>
                <p className="term-content">
                  &gt; {notes}
                </p>
              </div>

              {/* BOTTOM: Raw JSON Accordion + Kill Switch */}
              <div className="card-footer">
                <div className="card-actions">
                  <button 
                    className={`accordion-trigger ${expandedPatch === safeId ? 'open' : ''}`}
                    onClick={() => togglePatch(safeId)}
                  >
                    [ {expandedPatch === safeId ? 'HIDE' : 'VIEW'} RAW JSON ]
                  </button>
                  <button
                    className="kill-switch-btn"
                    onClick={() => handleDeleteTask(patch.task_id || patch.id)}
                  >
                    [ ✕ DELETE PATCH ]
                  </button>
                </div>
                
                {expandedPatch === safeId && (
                  <div className="json-container">
                    <pre>
                      <code>{JSON.stringify(patchObj, null, 2)}</code>
                    </pre>
                  </div>
                )}
              </div>

            </div>
          );
        })}
      </main>
    </div>
  );
};

export default Dashboard;
